import React, { Component } from "react";
import { Spin } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import VentasEcommerceDashboard from "./VentasEcommerceDashboard";
import VentasEcommerceTabla from "./VentasEcommerceTabla";

// Se escoge la vista segun la configuracion de la tienda
class VentasEcommerce extends Component {
  state = { loading: true, vistaTabla: false };

  componentDidMount() {
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionDashboard",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            vistaTabla: res.data.data?.vistaVentasEcommerce === "tabla",
          });
        }
      })
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const { loading, vistaTabla } = this.state;

    if (loading) {
      return (
        <div style={{ textAlign: "center", marginTop: 100 }}>
          <Spin size="large" />
        </div>
      );
    }

    return vistaTabla ? (
      <VentasEcommerceTabla history={this.props.history} />
    ) : (
      <VentasEcommerceDashboard history={this.props.history} />
    );
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(VentasEcommerce);
